import React from "react";
import { useNavigate } from "react-router-dom";

const TermsAndConditions = () => {
  const navigate = useNavigate();
  return (
    <div className="p-4 h-dvh flex flex-col bg-bg-grey">
      <div onClick={() => navigate(-1)}>
        <img src="/icons/backbtn.svg" alt="" />
      </div>
      <div className="mt-4 text-center text-20">Terms and Conditions</div>
      <div className="mt-2 bg-white85 rounded-[10px] p-2 px-3 border-[2px] overflow-y-auto border-[#00000020] flex-1 text-[15px] leading-relaxed">
        <div>
          <p>
            These Terms and Conditions, along with privacy policy or other terms
            (“Terms") constitute a binding agreement by and between KALPANECHA
            KARKHANA PRIVATE LIMITED, ("Website Owner" or "we" or "us" or "our")
            and you ("you" or "your") and relate to your use of our website,
            goods (as applicable) or services (as applicable) (collectively,
            “Services").
          </p>
          <p>
            By using our website and/or availing the Services, you agree that
            you have read and accepted these Terms (including the Privacy Policy
            as well as Refund and Cancellation Policy). We reserve the right to
            modify these Terms at any time and without assigning any reason. It
            is your responsibility to periodically review these Terms to stay
            informed of updates.
          </p>

          <h3 className="font-semibold mt-4">WHO WE ARE</h3>
          <p>
            Sangati.live Website and related Services are operated by KALPANECHA
            KARKHANA PRIVATE LIMITED (the “Company”). Please find more details
            in the Contact Us section down below.
          </p>

          <h3 className="font-semibold mt-4">
            WHEN YOU ACCEPT THESE TERMS OF USE
          </h3>
          <p>
            By using our Website and/ or Services, you indicate your acceptance
            of all the terms and conditions of this Agreement, our Privacy
            Policy as well as Refund and Cancellation Policy.
          </p>

          <h3 className="font-semibold mt-4">AGE RESTRICTION</h3>
          <p>
            Persons under 18 years of age are not allowed to use our Services,
            as they are not targeted at persons under the age of 18. Any data we
            receive from users we believe to be aged under 18 will be removed
            from our database. If you believe that we have collected, used or
            disclosed any data of a person under the age of 18 (or the age of
            majority in your jurisdiction), please contact our support team via
            the Contact Us section down below so that we can take appropriate
            action.
          </p>

          <h3 className="font-semibold mt-4">MEMBERSHIP</h3>
          <p>
            <strong>MEMBERS</strong>
            To access and use the Services, you agree to provide true, accurate
            and complete information to us during and after registration, and
            you shall be responsible for all acts done through the use of your
            registered account. When a user registers within the Services, they
            become a member (hereinafter - the "Member"). We do not influence
            the relationships between Members. Members may have only one account
            (hereinafter - “Membership”) with the Services. Multiple accounts
            will be blocked. Upon registering with the Services and thereby
            becoming a Member, you shall have access to the following Services:
          </p>
          <ul className="list-disc pl-5">
            <li>Answering the questions in the questionnaires.</li>
            <li>Checking your Compatibility with another member</li>
            <li>
              Having your profile registered in our database and making it
              searchable by other Members;
            </li>
            <li>Making changes to your profile;</li>
            <li>Purchasing Membership extensions for subsequent periods.</li>
          </ul>

          <h3 className="font-semibold mt-4">PURCHASING OF CREDIT POINTS</h3>
          <p>
            If you wish to use our Services not included in a free-use, you will
            have to subscribe to purchase credit points called Sangati Credits,
            which will allow you to calculate compatibility between 2 users.
          </p>
          <ul className="list-disc pl-5">
            <li>
              To calculate Emotional Compatibility, you will be charged 2
              credits, and to calculate sexual compatibility, you will also be
              charged 2 credits.
            </li>
            <li>
              If a user wishes to calculate both emotional and sexual
              compatibility, they will be charged 4 credits
            </li>
            <li>Users can purchase more credits anytime you want.</li>
            <li>All purchase history will be saved.</li>
            <li>All purchase invoices will be provided to the user.</li>
            <li>
              Per credit cost will be approx USD 0.1 (10 Cents USD) (Including
              taxes), as amended/ updated from time to time.
            </li>
            <li>
              Users need to Log In using their phone number to be able to
              purchase these credits
            </li>
          </ul>
          <p>
            Do not hesitate to contact us in case of any difficulties throughout
            the process. Once the Credit Points are purchased by you, the same
            shall not be refunded under any circumstances, whatsoever. In the
            event you delete the account and/ or not accessible to you due to
            reasons not attributable to us, the credit points shall stand
            forfeited and you shall not be entitled refund or compensation for
            the same. For further details you may check our terms of
            cancellations and refunds. The Credit Points cannot be sold,
            transferred or assigned by one user to another user.
          </p>

          <h3 className="font-semibold mt-4">TERMINATED ACCOUNTS OF MEMBERS</h3>
          <p>
            Members may terminate their Membership with us at any time. If a
            Member has requested her profile to be deleted from the Services for
            unspecified/personal reasons, we shall not have the right to receive
            any information with respect to the deletion of such a Member's
            profile, as it would be in violation of our Privacy Policy.
          </p>
          <p>
            If a Member is found on an anti-scam site, or in case we receive
            reliable proof of the Member's illegal or inappropriate activities,
            such Member's profile may be deleted from the Services provided that
            we, in our sole and unfettered discretion, consider the supplied
            information substantial and irrefutable and forfeit his/her credit
            points.
          </p>

          <h3 className="font-semibold mt-4">YOUR USE OF OUR SERVICES</h3>
          <h4 className="font-semibold mt-2 mb-1">ELIGIBILITY</h4>
          <p>
            By registering with our Services, you represent and warrant that you
            are at least 18 years old. You represent and warrant that you have
            the right, authority, and capacity to enter into this Agreement and
            to abide by all of the terms and conditions of this Agreement and
            have not been prohibited from using Services.
          </p>
          <h4 className="font-semibold mt-2 mb-1">
            CORRECTNESS OF INFORMATION YOU PROVIDE TO US
          </h4>
          <p>
            All information supplied when registering MUST be accurate, true and
            complete in all respects. In particular, when using a credit or
            debit card, the cardholder's name MUST be the same as the name used
            when registering with the Services, unless you provide valid and
            verifiable reasons for it being different. If we consider
            information you provide inaccurate or incomplete, we will suspend
            your account until identity verification has been satisfactorily
            completed. You may not authorize others to use your Membership, and
            you may not assign or otherwise transfer your account to any other
            person or entity.
          </p>
          <h4 className="font-semibold mt-2 mb-1">SECURITY AWARENESS</h4>
          <p>
            You must keep your password and all account details secret and
            confidential as you are responsible for use of the Services from
            your account and any other activities taking place on your account.
            Any transactions on your account will stand if your phone number and
            password have been entered correctly. We shall not be held liable
            for any data loss, breach, or unauthorized access resulting from the
            user's loss of access to their device, voluntary or negligent
            sharing of passwords, or any other failure to maintain the
            confidentiality and security of their account credentials. You
            assume full responsibility for safeguarding your access credentials
            and acknowledge that any consequences arising from such actions or
            omissions shall be solely your liability.
          </p>

          <h3 className="font-semibold mt-4">TERM</h3>
          <p>
            This Agreement will remain in full force and effect while you use
            our Services or have an account with us. You may terminate your
            Membership at any time, for any reason, by clicking the "Delete
            Account" button in the settings section of your Profile.
          </p>

          <h3 className="font-semibold mt-4">NON-COMMERCIAL USE OF SERVICES</h3>
          <p>
            Our Services are dedicated for the personal use of private
            individuals only and may not be used in connection with any
            commercial endeavours. Organizations, companies, businesses, and/or
            other entities may not become Members and are not entitled to use
            the Services for any purpose. Illegal and/or unauthorized use of the
            Services, including collecting usernames and/or email addresses of
            Members by electronic or other means for the purpose of sending
            unsolicited email and unauthorized framing of or linking to the
            Services will be investigated, and appropriate legal action may be
            taken, including without limitation, civil, criminal, and injunctive
            redress. You further guarantee and warrant that you (i) will not use
            the Services for any commercial purposes, and/or (ii) send or
            receive funds through the Services, and/or (iii) create accounts
            with fake usernames, or use any automated means (chatbots,
            artificial identities, etc.) in using the Services which do not
            represent a real natural person using the Services for her own
            private needs. You further guarantee and warrant that you will not
            be paid for using the Services. Such activity will be investigated,
            your Membership may be terminated and appropriate legal action may
            be taken, including without limitation, civil, criminal, and
            injunctive redress.
          </p>

          <h3 className="font-semibold mt-4">
            LINKED WEBSITES (IF APPLICABLE)
          </h3>
          <p>
            Depending on how you are using our Services, your needs and
            preferences, with the purpose to provide you with accurate
            compatibility result, we may register you with our linked websites
            or applications, operated by the Company or its affiliated companies
            (“Linked Websites”). By using the Linked Websites you agree with
            their terms and conditions, privacy policy and other regulations,
            published by them.
          </p>

          <h3 className="font-semibold mt-4">CONTENT POSTED BY YOU</h3>
          <p>
            You understand and agree that for the protection of our Members we
            may at our sole discretion store for review and delete any content,
            messages, photos, videos, audio and video calls or profiles
            (collectively, "Content") that in our sole judgment violate this
            Agreement or which might be offensive, illegal, or that might
            violate the rights of, harm, or threaten the safety of other
            Services users or any third parties.
          </p>

          <h3 className="font-semibold mt-4">
            PROHIBITED CONTENT AND ACTIVITIES
          </h3>
          <p>
            The following is a partial list of Content that is illegal or
            prohibited on our Services. Users are encouraged to report
            suspicious or inappropriate content through our reporting
            mechanisms. Additionally, we conduct automated content audits to
            identify and address violations. We reserve the right to investigate
            and take appropriate legal action, at our sole discretion, against
            anyone who violates this provision, including, but not limited to,
            removing offending communications from the Services and terminating
            the violator's Membership.
          </p>
          <ul className="list-disc pl-5">
            <li>
              Offensive Content: Content that promotes racism, bigotry, hatred,
              or physical harm of any kind against any group or individual.
            </li>
            <li>
              Harassment: Content that harasses or advocates harassment of
              another person.
            </li>
            <li>
              Spam and Unsolicited Communications: Content involving the
              transmission of junk mail, "chain letters," unsolicited mass
              mailings, or spamming.
            </li>
            <li>
              Defamatory or Illegal Activities: Content that is defamatory,
              false, misleading, or promotes illegal activities, or conduct that
              is abusive, threatening, obscene, or libelous.
            </li>
            <li>
              Copyright Violations: Content that promotes unauthorized copies of
              copyrighted work, including pirated software, music, or other
              materials.
            </li>
            <li>
              Restricted or Hidden Content: Content that includes restricted or
              password-only access pages or hidden pages/images not linked to or
              accessible from another page.
            </li>
            <li>
              Inappropriate Material: Content that publicly displays
              inappropriate material, including nudity, pornography, bestiality,
              graphic violence, or criminal activity.
            </li>
            <li>
              Exploitation and Human Trafficking: Content that exploits
              individuals, particularly people under the age of 18, in a sexual
              or violent manner. Content that solicits, promotes, or facilitates
              any form of human trafficking, including sexual exploitation,
              forced labor, or modern slavery. Content that uses the platform to
              solicit or coerce others into illegal activities, including
              prostitution or escort services.
            </li>
            <li>
              We enforce a zero-tolerance policy for any form of exploitation or
              trafficking and collaborates with law enforcement and
              anti-trafficking organizations to investigate and address such
              violations.
            </li>
            <li>
              Illegal Activity Guides: Content that provides instructional
              information on illegal activities, such as making or buying
              illegal weapons, violating someone's privacy, or creating computer
              viruses or malware.
            </li>
            <li>
              Solicitation of Sensitive Information: Content that solicits
              passwords, personal identifying information, or financial
              information for commercial or unlawful purposes.
            </li>
            <li>
              Unauthorized Commercial Activities: Content that involves buying,
              selling, or advertising products or services without prior written
              consent. Content engaging in commercial activities such as
              contests, sweepstakes, barter, advertising, or Ponzi schemes
              without authorization.
            </li>
          </ul>

          <h4 className="font-semibold mt-2 mb-1">Enforcement and Reporting</h4>
          <p>
            We are committed to ensuring a safe platform and encourage all users
            to report prohibited content promptly. Violators of this policy will
            face account suspension, termination, and, where applicable,
            reporting to relevant authorities.
          </p>

          <h3 className="font-semibold mt-4">EMAILS AND TEXT MESSAGES</h3>
          <p>
            Although we cannot monitor the conduct of our Members off the
            Services, it is also a violation of these rules to use any
            information obtained from the Services in order to harass, abuse, or
            harm another person, or in order to contact, advertise to, solicit,
            or sell to any Member without their prior explicit consent. By
            providing your phone number(s), you confirm that the number(s)
            belongs to you and you expressly consent to receive non-marketing
            and marketing text messages from us, at the telephone number(s) that
            you provide. You may opt-out of these communications at any time,
            and consent to receive text messages is not required to purchase any
            goods or services. Your phone number will only be visible to you.
          </p>

          <h3 className="font-semibold mt-4">OTHER RULES</h3>
          <p>
            You must use the Services in a manner consistent with any and all
            applicable laws and regulations. Your Content must comply with
            applicable international, national and local laws and regulations.
            You may not collect any data from the Services either from
            authorized and non-authorized zones through automated means (bots,
            spiders, scrapers or equivalent means), by establishing fake user
            accounts, by anonymous proxy servers or equivalent measures, or by
            circumventing any technical measures to prevent forbidden activity
            on the Services. You may not collect data from authorized zones of
            the Services by any other means including manual collection of data.
            To ensure the service quality, your information and answers given to
            us through Website or App may be recorded and stored, however, the
            same shall not be shared by us to any third party or any other user.
            You are solely responsible for your actions and interactions with
            other users of the Services.
          </p>

          <h3 className="font-semibold mt-4">TERMINATION</h3>
          <p>
            We may terminate your registration due to any breach of the terms
            and conditions committed by you or any other person through your
            account, with or without explanation, effective upon sending a
            message to your phone number provided at registration, or to any
            other phone number provided by you to us. Upon termination by us
            without cause, your credit points shall be forfeited and you shall
            not be entitled to any refund. We reserve the right to investigate,
            terminate Membership and take appropriate legal action at our sole
            discretion against anyone who violates this Agreement, Privacy
            Policy as well as Refund and Cancellation Policy.
          </p>
          <p>
            If your Membership with our Services is terminated by reason of
            violation of this Agreement, Privacy Policy as well as Refund and
            Cancellation Policy, or at your own request, you will not be
            entitled to, nor shall we be liable to you, for any refund of unused
            fees for using the Services. Notwithstanding your registration with
            us being terminated, this Agreement will remain in full effect.
          </p>

          <h3 className="font-semibold mt-4">DISCLAIMER</h3>
          <p>
            WE PROVIDE THE SERVICES ON AN "AS IS" BASIS AND GRANT NO WARRANTIES
            OF ANY KIND, EXPRESSED, IMPLIED OR STATUTORY, IN ANY COMMUNICATION
            WITH OUR REPRESENTATIVES, OTHERWISE WITH RESPECT TO THE SERVICES. WE
            SPECIFICALLY DISCLAIM ANY IMPLIED WARRANTIES OF MERCHANTABILITY OR
            FITNESS FOR A PARTICULAR PURPOSE. FURTHER, WE DO NOT WARRANT THAT
            YOUR USE OF THE SERVICES WILL BE SECURE, UNINTERRUPTED, ALWAYS
            AVAILABLE OR ERROR-FREE, OR THAT THE SERVICES WILL MEET YOUR
            REQUIREMENTS OR THAT ANY DEFECTS IN THE SERVICES WILL BE CORRECTED.
            WE DISCLAIM LIABILITY FOR, AND NO WARRANTY IS MADE WITH RESPECT TO,
            CONNECTIVITY AND AVAILABILITY.
          </p>
          <p>
            Although each Member must agree to the Agreement, we cannot
            guarantee that each Member is at least the required minimum age, nor
            does it accept responsibility or liability for any content,
            communication or other use or access of the Services by persons
            under the age of 18 in violation of this Agreement.
          </p>
          <p>
            WE DISCLAIM ALL LIABILITY, REGARDLESS OF THE FORM OF ACTION, FOR THE
            ACTS OR OMISSIONS OF OTHER MEMBERS OR USERS (INCLUDING UNAUTHORIZED
            USERS), WHETHER SUCH ACTS OR OMISSIONS OCCUR DURING THE USE OF THE
            SERVICES OR OTHERWISE.
          </p>
          <p>
            We assume no responsibility for any error, omission, interruption,
            deletion, defect, delay in operation or transmission, communications
            line failure, theft or destruction or unauthorized access to, or
            alteration of, user communications. We are not responsible for any
            problems or technical malfunction of any telephone network or lines,
            computer online systems, servers or providers, computer equipment,
            software, failure of email or players on account of technical
            problems or traffic congestion on the Internet or at any of the
            Services or combination thereof, including injury or damage to users
            or to any other person's property related to or resulting from
            participating or downloading materials in connection with the web
            and/or in connection with the Services.
          </p>
          <p>
            UNDER NO CIRCUMSTANCES WILL WE BE RESPONSIBLE FOR ANY LOSS OR
            DAMAGE, INCLUDING PERSONAL INJURY OR DEATH, RESULTING FROM ANYONE'S
            USE OF THE SERVICES, ANY CONTENT POSTED WITHIN THE SERVICES OR
            TRANSMITTED TO USERS, OR ANY INTERACTIONS BETWEEN USERS OF THE
            SERVICES, WHETHER ONLINE OR OFFLINE.
          </p>

          <h3 className="font-semibold mt-4">LIMITATION OF LIABILITY</h3>
          <p>
            Except in jurisdictions where such provisions are restricted, in no
            event will we be liable to you or any third person for any indirect,
            consequential, exemplary, incidental, special or punitive damages,
            including also lost profits arising from your use of the Services,
            as well as damages for loss of data, loss of programs, cost of
            procurement of substitute Services or interruptions of the Services,
            even if we know or has been advised of the possibility of such
            damages.
          </p>
          <p>
            We are not responsible for any activities outside of our Services
            (including, but not limited to expenses related to travel,
            deliveries, meetings etc.). Those expenses are your own
            responsibility. Notwithstanding anything to the contrary contained
            herein, our liability to you for any cause whatsoever, and
            regardless of the form of the action, will at all times be limited
            to the amount paid, if any, by you to us for the Services during the
            term of Membership.
          </p>

          <h3 className="font-semibold mt-4">SUPPLIERS</h3>
          <p>
            When we run the Services, we may be serviced by various third
            parties and affiliate marketing partners (collectively,
            “Suppliers”). The Suppliers are independent contractors and are not
            agents, or employees of the Company. We are not responsible for the
            willful or negligent acts and/or omissions of any Supplier or any of
            its respective employees, agents, servants or representatives
            including, without limitation, their failure to deliver Services, or
            partial or inadequate delivery of Services.
          </p>
          <p>
            According to terms of agreement with our Suppliers, we are
            prohibited from rendering the Suppliers' contact information.
            Suppliers provide full, accurate and legitimate information required
            for the registration of Members within the Services prior to their
            registration according to the terms of Agreement. Each supplier may
            provide translation services for the registered Members and have
            access to all the correspondence of such Members. Suppliers provide
            additional services in accordance to the terms of their agreement
            with us. Any additional services requested by our Members, which
            fall into the Suppliers scope of activity, but not defined by our
            terms of Agreement with Supplier, may be processed by Suppliers, but
            are not automatically granted. We are not in any way responsible for
            the quality of any additional services provided by the Suppliers.
          </p>

          <h3 className="font-semibold mt-4">CONTACT US</h3>
          <p>
            Please send all the requests, communications, inquiries,
            clarifications and provision of information to our support team via
            email at{" "}
            <a href="mailto:support@karkhana.world">support@karkhana.world</a>
            <br />
            Customer support number: +917620774681. Please note that our
            customer support service may not work outside business hours in your
            area.
          </p>

          <h3 className="font-semibold mt-4">DISPUTES</h3>
          <p>
            Any dispute or claim relating in any way to your use of the Services
            sold or distributed by or through the Company shall be resolved in
            the following manner.
          </p>
          <ol className="list-decimal pl-5">
            <li>
              <strong>Informal Process First.</strong> You agree to first
              contact our customer support by email and attempt to resolve the
              dispute with us informally for a period of 60 days. Please refer
              to Contact Us for details.
            </li>
            <li>
              <strong>Binding Arbitration.</strong> If the dispute has not been
              resolved in 60 days, we each agree to resolve any claim, dispute,
              or controversy arising out of or in connection with or relating to
              the Services and/or this Agreement, or the breach or alleged
              breach thereof, including disputes related to the applicability,
              enforceability, interpretation or formation of this Agreement to
              arbitrate, by binding arbitration.
            </li>
            <li>
              <strong>Applicable Laws:</strong> These Terms and any dispute or
              claim relating to it, or its enforceability, shall be governed by
              and construed in accordance with the laws of India. All disputes
              arising out of or in connection with these Terms shall be subject
              to the exclusive jurisdiction of the courts in Pune, Maharashtra
            </li>
          </ol>

          <h3 className="font-semibold mt-4">MISCELLANEOUS</h3>
          <p>
            You agree to indemnify and hold the Company, its subsidiaries,
            affiliates, officers, agents, and other partners and employees,
            harmless from any loss, liability, claim, or demand, including
            reasonable attorney's fees, made by any third party due to or
            arising out of your use of the Services in violation of this
            Agreement, and/or any allegations that any Content that you submit
            to us or transmit to the Services infringe or otherwise violate the
            copyright, trademark, trade secret or other intellectual property or
            other rights of any third party; and/or arising from a breach of
            this Agreement and/or any breach of Your representations and
            warranties set forth above. This indemnity shall be applicable
            without regard to the negligence of any party, including any
            indemnified person.
          </p>

          <h3 className="font-semibold mt-4">LANGUAGE</h3>
          <p>
            The English version of this Agreement shall prevail over this
            Agreement in any other language. If you are using our Services in
            English, you waive your right to claim from us correspondence or any
            document in other languages.
          </p>

          <h3 className="font-semibold mt-4">ENTIRE AGREEMENT</h3>
          <p>
            This Agreement, accepted upon use of the Services and further
            affirmed by becoming a Member, contains the entire Agreement between
            you and us regarding the use of the Services. If any provision of
            this Agreement is held invalid, the remainder of this Agreement
            shall continue in full force and effect. The terms and conditions of
            this Agreement are subject to change by us at any time, effective
            upon notice to you, which notice shall be deemed to have been
            provided upon our posting of the current version of this Agreement
            within the Services. Please note the latest modification date at the
            top of this Agreement.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
